
import PricingTable from './PricingTable';

const PricingSection = () => {
  return (
    <section id="pricing-section" className="py-20 bg-primary/5">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <div className="inline-block px-3 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full mb-3">
            Pricing Plans
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Choose Your Plan</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Select the plan that best suits your career development needs
          </p>
        </div>
        
        <PricingTable />
      </div>
    </section>
  );
};

export default PricingSection;
